import { createAsyncThunk } from "@reduxjs/toolkit";
import doFetch from "../../infrastructure/doFetch";
import { SPINNER_NAMES } from "../../components/organisms/Spinner";
import { getQueryParams } from "../../helpers";
import { EMPTY_STRING } from "../../constants";

const {
  FETCH_MULESOFT_ENDPOINTS,
  CREATE_MULESOFT_ENDPOINT,
  DELETE_ENDPOINT,
  CREATE_INTEGRATION,
  FETCH_MULESOFT_INTEGRATIONS,
  FETCH_INTEGRATION,
  FETCH_MULESOFT_SWAGGER_DATA,
} = SPINNER_NAMES;

export const fetchMulesoftEndpoints = createAsyncThunk(
  "fetch-mulesoft-endpoints",
  async ({ id, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `xmlhandler?integrationId=${id}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_MULESOFT_ENDPOINTS,
      errorMessage:
        "Unable to fetch mulesoft endpoints. Please try again later.",
      successMessage: "Successfully fetched mulesoft endpoints.",
      ...args,
    })
);

export const createMulesoftEndpoint = createAsyncThunk(
  "create-mulesoft-endpoint",
  async ({ data, id, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `xmlhandler?integrationId=${id}`,
      method: "POST",
      config: {
        body: data,
      },
      useCache,
      showSpinner,
      spinner: CREATE_MULESOFT_ENDPOINT,
      errorMessage: "Unable to create endpoint. Please try again later.",
      successMessage: "Successfully created endpoint",
      ...args,
    })
);

export const deleteMulesoftEndpoint = createAsyncThunk(
  "delete-mulesoft-endpoint",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `endpoints/${id}`,
      method: "DELETE",
      useCache,
      showSpinner,
      spinner: DELETE_ENDPOINT,
      errorMessage: "Unable to delete endpoint. Please try again later.",
      successMessage: "Successfully deleted endpoint.",
      ...args,
    })
);

export const fetchMulesoftSwaggerData = createAsyncThunk(
  "fetch-mulesoft-swagger-data",
  async ({ integrationId, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `swagger?integrationId=${integrationId}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_MULESOFT_SWAGGER_DATA,
      errorMessage:
        "Unable to fetch mulesoft swagger data. Please try again later.",
      successMessage: "Successfully fetched mulesoft swagger data.",
      ...args,
    })
);

export const createIntegration = createAsyncThunk(
  "create-Integration",
  async (integrationDetails, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `integrations`,
      method: "POST",
      config: {
        body: JSON.stringify(integrationDetails),
      },
      useCache,
      showSpinner,
      spinner: CREATE_INTEGRATION,
      errorMessage: "Unable to create integration. Please try again later.",
      successMessage: "Successfully created integration.",
      ...args,
    })
);

export const fetchMuleIntegrations = createAsyncThunk(
  "fetch-mulesoft-integrations",
  async (filters, args, { useCache, showSpinner } = {}) => {
    const queryParams = getQueryParams(filters) || EMPTY_STRING;
    return doFetch({
      url: `integrations?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_MULESOFT_INTEGRATIONS,
      errorMessage: "Unable to fetch integrations. Please try again later.",
      successMessage: "Successfully fetched integrations.",
      ...args,
    });
  }
);

export const fetchIntegration = createAsyncThunk(
  "fetch-integration",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `integrations/${id}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_INTEGRATION,
      errorMessage: "Unable to fetch integration. Please try again later.",
      successMessage: "Successfully fetched integration.",
      ...args,
    })
);

export const deleteMuleIntegration = createAsyncThunk(
  "delete-mulesoft-integration",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `integrations/${id}`,
      method: "DELETE",
      useCache,
      showSpinner,
      errorMessage: "Unable to delete integration. Please try again later.",
      successMessage: "Successfully deleted integration.",
      ...args,
    })
);

export const updateIntegrationDetails = createAsyncThunk(
  "update-integration-details",
  async ({ id, integrationDetails, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `integrations/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(integrationDetails),
      },
      useCache,
      showSpinner,
      errorMessage:
        "Unable to update integration details. Please try again later.",
      successMessage: "Successfully updated integration details.",
      ...args,
    })
);
